/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Ai_Fields_ContentInputs */

const cs_property_ai_fields_content = /** @type {(inputs: Property_Ai_Fields_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jen obsah`)
};

const en_property_ai_fields_content = /** @type {(inputs: Property_Ai_Fields_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Content only`)
};

/**
* | output |
* | --- |
* | "Content only" |
*
* @param {Property_Ai_Fields_ContentInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_ai_fields_content = /** @type {((inputs?: Property_Ai_Fields_ContentInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Ai_Fields_ContentInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_ai_fields_content(inputs)
	return cs_property_ai_fields_content(inputs)
});